import WeatherMoonFilled from './src/weather-moon-filled';
export default WeatherMoonFilled;